import { EditorState, ContentState, convertFromHTML, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";

export const initializeExplanationEditorState = (explanation, existingState) => {
  if (existingState) return existingState;
  if (explanation && explanation.length > 0 && explanation !== "<p></p>\n") {
    return EditorState.createWithContent(
      ContentState.createFromBlockArray(
        convertFromHTML(explanation).contentBlocks,
        convertFromHTML(explanation).entityMap
      )
    );
  }
  return EditorState.createEmpty();
};

export const isExplanationEmpty = (explanation) => {
  return !explanation || explanation.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "").length < 1;
};

export const buildExplanationStates = (attributeData, existingStates) => {
  return attributeData.map((attr, aIdx) => ({
    explanations: attr.questions.map((q, qIdx) =>
      initializeExplanationEditorState(q.explanation, existingStates[aIdx]?.explanations[qIdx])
    ),
  }));
};

export const editorStateToHtml = (state) => {
  return draftToHtml(convertToRaw(state.getCurrentContent()));
};
